import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeaderMal";
import line from "../../../Images/line.jpeg";

var sectionStyle = {
  backgroundImage: `url(${line})`
};

class ReceiptEntry extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <>
        <div className="p-2 border border-dark">
          <ReportHeader onCloseClick={this.onCloseClick} IsClose="0" />
          <h2 align="center">Equipment Dispose</h2>
          <div className="container-fluid reportFont">
            <div className="row p-3 ">
              <div className="col-3"></div>
              <div className="col-6"></div>
              <div className="col-3" align="right">
                Date : {this.props.data.date}
              </div>
            </div>
            <div className="row p-1" style={sectionStyle}>
              <div className="col-3">Equipment :</div>
              <div className="col-7">{this.props.data.name}</div>
            </div>
            <div className="row p-1 " style={sectionStyle}>
              <div className="col-3">Quantity :</div>
              <div className="col-7">{this.props.data.qty}</div>
            </div>
            <div className="row p-1 " style={sectionStyle}>
              <div className="col-3">Description :</div>
              <div className="col-7">{this.props.data.desc}</div>
            </div>
            <div className="row pt-5 ">
              <div className=" col-3" align="right"></div>
              <div className="col-3 align-bottom" align="right"></div>
              <div className="col-3" align="right">
                Prepared By
              </div>
              <div className="col-3" align="right">
                Authorized By
              </div>
            </div>
          </div>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}

export default ReceiptEntry;
